/**
 * Fusionne les clé et leurs valeurs de deux objets en un. Les clés du deuxième objet vont écraser les clés du premier objet.
 *
 * @param {object} obj1 Premier objet.
 * @param {object} obj2 Deuxième objet.
 * @returns {object} Objet fusionné.
 */
function ff_merge_objects(obj1, obj2) {
  const obj3 = {};
  for (const attrname in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, attrname)) {
      obj3[attrname] = obj1[attrname];
    }
  }
  for (const attrname in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, attrname)) {
      obj3[attrname] = obj2[attrname];
    }
  }
  return obj3;
}


// Exportation
export { ff_merge_objects }; // eslint-disable-line import/prefer-default-export
